import { defineComponent as _defineComponent } from 'vue'
import LoanApplication from '@/models/LoanApplication';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationBadge',
  props: {
    application: null
  },
  setup(__props: any) {

const props = __props as {
 application: LoanApplication;
}



return { __sfc: true,props }
}

})